<template>
  <div class="index-page">
    <router-view/>
  </div>
</template>
<script>
export default {};
</script>
<style>
  .index-page {
    height: 100%;
  }
</style>
